import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../api';
import Icon from './Icon';
import useDialogFocus from '../hooks/useDialogFocus';

const SUBCATEGORIES = {
  одежда: [
    'Анораки',
    'Бермуды',
    'Блузки',
    'Блузки-боди',
    'Болеро',
    'Бомберы',
    'Бриджи',
    'Брюки',
    'Велосипедки',
    'Ветровки',
    'Водолазки',
    'Дафлкоты',
    'Джеггинсы',
    'Джемперы',
    'Джинсы',
    'Дождевики',
    'Дубленки',
    'Жакеты',
    'Жилеты',
    'Капри',
    'Кардиганы',
    'Карнавальные костюмы',
    'Кейпы',
    'Кигуруми',
    'Килты банные',
    'Комбинезоны',
    'Косухи',
    'Костюмы',
    'Кофты',
    'Крестильные комплекты',
    'Куртки',
    'Леггинсы',
    'Лонгсливы',
    'Мантии',
    'Ночные сорочки',
    'Пальто',
    'Парки',
    'Пеньюары',
    'Пиджаки',
    'Пижамы',
    'Платья',
    'Плащи',
    'Полукомбинезоны',
    'Полупальто',
    'Пончо',
    'Пуловеры',
    'Пуховики',
    'Рубашки',
    'Сарафаны',
    'Свитеры',
    'Свитшоты',
    'Твинсеты',
    'Толстовки',
    'Топы',
    'Тренчкоты',
    'Туники',
    'Футболки',
    'Футболки-поло',
    'Халаты банные',
    'Халаты домашние',
    'Худи',
    'Шорты',
    'Шубы искусственные',
    'Шубы натуральные',
    'Юбки',
  ].sort(),
  обувь: [
    'Балетки',
    'Босоножки',
    'Ботильоны',
    'Ботинки',
    'Ботфорты',
    'Валенки',
    'Галоши',
    'Дутики',
    'Кеды',
    'Кроссовки',
    'Лоферы',
    'Луноходы',
    'Мокасины',
    'Мюли',
    'Полуботинки',
    'Полусапожки',
    'Резиновые сапоги',
    'Сабо',
    'Сандалии',
    'Сапоги',
    'Слипоны',
    'Сноубутсы',
    'Тапочки',
    'Туфли',
    'Угги',
    'Унты',
    'Шлепанцы',
    'Эспадрильи',
  ].sort(),
  аксессуары: [
    'Багажные бирки',
    'Банданы',
    'Бабочки',
    'Браслеты для часов',
    'Веера',
    'Визитницы',
    'Воротники',
    'Галстуки',
    'Горжетки',
    'Декор для одежды',
    'Декор для сумок и рюкзаков',
    'Держатели для очков',
    'Зажимы для денег',
    'Зеркальца',
    'Зонты',
    'Имиджевые очки',
    'Инструменты и запчасти для часов',
    'Клатчи',
    'Клипсы и расширители для пояса',
    'Ключницы',
    'Косметички',
    'Косточки для воротника рубашки',
    'Кошельки',
    'Кредитницы',
    'Манжеты',
    'Манишки',
    'Маски для сна',
    'Митенки',
    'Монетницы',
    'Муфты для рук',
    'Накладные плечи',
    'Носовые платки',
    'Обложки',
    'Обложки для документов',
    'Органайзеры для сумки',
    'Палантины',
    'Парео',
    'Перчатки',
    'Платки',
    'Подворотнички одноразовые',
    'Подкладки для сумок',
    'Подтяжки',
    'Портфели',
    'Портупеи',
    'Пояса',
    'Пряжки',
    'Ремни',
    'Ремни для сумок',
    'Ремни для часов',
    'Ручки для сумок',
    'Рюкзаки',
    'Снуды',
    'Солнцезащитные очки',
    'Сумки',
    'Сумки-тележки',
    'Сумки хозяйственные',
    'Сумки-шопперы',
    'Темляки',
    'Фата',
    'Фиксаторы для очков',
    'Формодержатели для сумок',
    'Фурнитура для чемоданов',
    'Футляры для очков',
    'Цепочки для очков',
    'Часы карманные',
    'Часы наручные',
    'Часы-кулон',
    'Чемоданы',
    'Чехлы для сумок и рюкзаков',
    'Чехлы для чемоданов',
    'Шали',
    'Шапки для сна',
    'Шарфы',
    'Шарфы-пледы',
    'Шнурки для очков',
    'Штрипки для брюк',
  ].sort(),
};

function Sidebar({ isOpen, onClose }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [drawer, setDrawer] = useState(() => window.innerWidth < 1024);
  useEffect(() => {
    const media = window.matchMedia('(max-width: 1023px)');
    const update = () => setDrawer(media.matches);
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);
  const panel = useDialogFocus(isOpen && drawer, onClose);
  const currentCategory = searchParams.get('category') || '';
  const currentSubcategory = searchParams.get('subcategory') || '';
  const currentBrand = searchParams.get('brand') || '';
  const currentSize = searchParams.get('size') || '';
  const currentColor = searchParams.get('color') || '';
  const currentMinPrice = searchParams.get('min_price') || '';
  const currentMaxPrice = searchParams.get('max_price') || '';
  const currentSort = searchParams.get('sort') || 'default';

  const [brands, setBrands] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [colors, setColors] = useState([]);

  useEffect(() => {
    api
      .get('/api/products/brands')
      .then((res) => setBrands(res.data))
      .catch(() => {});
    api
      .get('/api/products/sizes')
      .then((res) => setSizes(res.data))
      .catch(() => {});
    api
      .get('/api/products/colors')
      .then((res) => setColors(res.data))
      .catch(() => {});
  }, []);

  const updateParam = (key, value) => {
    const newParams = new URLSearchParams(searchParams);
    if (
      value === '' ||
      value === null ||
      value === undefined ||
      value === 'default'
    ) {
      newParams.delete(key);
    } else {
      newParams.set(key, value);
    }
    // При смене категории сбрасываем подкатегорию
    if (key === 'category') {
      newParams.delete('subcategory');
    }
    setSearchParams(newParams);
  };

  const subcategories = SUBCATEGORIES[currentCategory] || [];

  return (
    <>
      <div
        className={`sidebar-overlay ${isOpen && drawer ? 'open' : ''}`}
        onClick={onClose}
        aria-hidden="true"
      />
      <aside
        ref={panel}
        id="catalog-filters"
        className={`sidebar-filter ${isOpen ? 'open' : ''}`}
        role={drawer ? 'dialog' : undefined}
        aria-modal={drawer && isOpen ? true : undefined}
        aria-label="Фильтры каталога"
        aria-hidden={!isOpen ? true : undefined}
        inert={!isOpen ? '' : undefined}
        tabIndex={-1}
      >
        <div className="sidebar-header">
          <h3>Фильтры</h3>
          <button
            className="sidebar-close"
            onClick={onClose}
            aria-label="Закрыть фильтры"
          >
            <Icon name="close" />
          </button>
        </div>

        {/* Сортировка */}
        <div className="filter-section">
          <h3 className="filter-title">Сортировка</h3>
          <select
            aria-label="Сортировка товаров"
            value={currentSort}
            onChange={(e) =>
              updateParam(
                'sort',
                e.target.value === 'default' ? '' : e.target.value
              )
            }
            className="filter-select"
          >
            <option value="default">По популярности (продажам)</option>
            <option value="newest">По новизне</option>
            <option value="price_asc">Сначала дешёвые</option>
            <option value="price_desc">Сначала дорогие</option>
          </select>
        </div>

        {/* Категории */}
        <div className="filter-section">
          <h3 className="filter-title">Категории</h3>
          <div className="filter-options">
            {['одежда', 'обувь', 'аксессуары'].map((cat) => (
              <label key={cat} className="filter-option">
                <input
                  type="radio"
                  name="category"
                  checked={currentCategory === cat}
                  onChange={() => updateParam('category', cat)}
                />
                <span style={{ textTransform: 'capitalize' }}>{cat}</span>
              </label>
            ))}
            {currentCategory && (
              <button
                onClick={() => updateParam('category', '')}
                className="btn-clear"
              >
                Сбросить
              </button>
            )}
          </div>
        </div>

        {/* Подкатегория */}
        {subcategories.length > 0 && (
          <div className="filter-section">
            <h3 className="filter-title">Подкатегория</h3>
            <select
              aria-label="Подкатегория"
              value={currentSubcategory}
              onChange={(e) => updateParam('subcategory', e.target.value)}
              className="filter-select"
            >
              <option value="">Все подкатегории</option>
              {subcategories.map((sc) => (
                <option key={sc} value={sc}>
                  {sc}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Бренд */}
        <div className="filter-section">
          <h3 className="filter-title">Бренд</h3>
          <select
            aria-label="Бренд"
            value={currentBrand}
            onChange={(e) => updateParam('brand', e.target.value)}
            className="filter-select"
          >
            <option value="">Все бренды</option>
            {brands.map((b) => (
              <option key={b} value={b}>
                {b}
              </option>
            ))}
          </select>
        </div>

        {/* Размер */}
        <div className="filter-section">
          <h3 className="filter-title">Размер</h3>
          <select
            aria-label="Размер"
            value={currentSize}
            onChange={(e) => updateParam('size', e.target.value)}
            className="filter-select"
          >
            <option value="">Все размеры</option>
            {sizes.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>

        {/* Цвет */}
        <div className="filter-section">
          <h3 className="filter-title">Цвет</h3>
          <select
            aria-label="Цвет"
            value={currentColor}
            onChange={(e) => updateParam('color', e.target.value)}
            className="filter-select"
          >
            <option value="">Все цвета</option>
            {colors.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        </div>

        {/* Цена */}
        <div className="filter-section">
          <h3 className="filter-title">Цена</h3>
          <div className="price-inputs">
            <input
              type="number"
              placeholder="От"
              aria-label="Минимальная цена"
              min="0"
              value={currentMinPrice}
              onChange={(e) => updateParam('min_price', e.target.value)}
              className="price-input"
            />
            <span className="price-separator">–</span>
            <input
              type="number"
              placeholder="До"
              aria-label="Максимальная цена"
              min="0"
              value={currentMaxPrice}
              onChange={(e) => updateParam('max_price', e.target.value)}
              className="price-input"
            />
          </div>
        </div>
        <button
          className="filter-reset-button"
          onClick={() =>
            setSearchParams((current) => {
              const next = new URLSearchParams();
              if (current.get('search'))
                next.set('search', current.get('search'));
              return next;
            })
          }
        >
          Сбросить фильтры
        </button>
        <button
          className="btn btn-primary filter-drawer-apply"
          onClick={onClose}
        >
          Показать товары
        </button>
      </aside>
    </>
  );
}

export default Sidebar;
